"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.BadgeSizes = void 0;
var _react = _interopRequireWildcard(require("react"));
var _theme = _interopRequireDefault(require("../../theme"));
var _Box = _interopRequireDefault(require("../Box"));
var _styledComponents = require("./styled-components");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var BadgeSizes = exports.BadgeSizes = /*#__PURE__*/function (BadgeSizes) {
  BadgeSizes["small"] = "small";
  BadgeSizes["medium"] = "medium";
  BadgeSizes["large"] = "large";
  return BadgeSizes;
}({});
var Badge = /*#__PURE__*/(0, _react.forwardRef)(function BadgeComponent(_ref, ref) {
  var text = _ref.text,
    _ref$backgroundColor = _ref.backgroundColor,
    backgroundColor = _ref$backgroundColor === void 0 ? _theme["default"].dataVisualisationLightPurple : _ref$backgroundColor,
    _ref$textColor = _ref.textColor,
    textColor = _ref$textColor === void 0 ? 'light' : _ref$textColor,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'small' : _ref$size,
    _ref$uppercase = _ref.uppercase,
    uppercase = _ref$uppercase === void 0 ? true : _ref$uppercase,
    ariaDescribedby = _ref.ariaDescribedby,
    renderIcon = _ref.renderIcon;
  return /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    px: 2
    // @ts-ignore
    ,
    py: setBadgePaddingSize(size),
    backgroundColor: backgroundColor,
    borderRadius: setBadgeBorderRadius(size),
    alignSelf: "baseline",
    display: "inline-flex",
    "aria-describedby": ariaDescribedby,
    alignItems: "center",
    ref: ref
  }, typeof renderIcon === 'function' ? /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    mr: "space05",
    justifyContent: "center",
    alignItems: "center",
    display: "inline-flex"
  }, renderIcon({
    size: setBadgeIconSize(size),
    color: (0, _styledComponents.getTextColor)(textColor)
  })) : null, /*#__PURE__*/_react["default"].createElement(_styledComponents.BadgeText, {
    size: size,
    color: textColor,
    uppercase: uppercase
  }, text));
});
var setBadgeIconSize = function setBadgeIconSize(size) {
  switch (size) {
    case 'large':
      return 16;
    case 'medium':
      return 14;
    default:
      return 10;
  }
};
var setBadgePaddingSize = function setBadgePaddingSize(size) {
  switch (size) {
    case 'large':
      return '7px';
    case 'medium':
      return '3px';
    default:
      return '0px';
  }
};
var setBadgeBorderRadius = function setBadgeBorderRadius(size) {
  switch (size) {
    case 'large':
      return '8px';
    default:
      return '4px';
  }
};
var _default = exports["default"] = Badge;